<div class="grid-container padding-bottom-4">
    <div class="grid-row">
        <div class="grid-col-10">
            <legend class="usa-legend usa-legend--large">{{shipmentType}} - Control Screen</legend>
        </div>
    </div>
    <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
            <legend class="usa-legend usa-legend--medium">Shipper Information</legend>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Shipper:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{ shipperInfo ? shipperInfo.firstName : '' }} {{shipperInfo ? shipperInfo.lastName : '' }}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Customer:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{ agencyInfo ? agencyInfo.agencyBureauName : ''}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Phone:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{shipperInfo ? shipperInfo.phone : '' }}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Email:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{shipperInfo ? shipperInfo.email : '' }}
                </div>
            </div>
            <legend class="usa-legend usa-legend--medium">TSP Information</legend>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    SCAC:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{carrier ? carrier.scac : ''}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Phone:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    Email:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    {{carrierOrganizationInfo? carrierOrganizationInfo.email : ''}}
                </div>
            </div>
            <div class="grid-row grid-gap-1 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <legend class="usa-legend usa-legend--medium">Origin</legend>
                    <div>{{originAddress}}</div>
                    <div>{{originCountry}}</div>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <legend class="usa-legend usa-legend--medium">Destination</legend>
                    <div>{{destinationAddress}}</div>
                    <div>{{destinationCountry}} </div>
                </div>
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-7 desktop:grid-col-7 border-left-2px border-base define-padding-left">
            <legend class="usa-legend usa-legend--medium">Shipment Information</legend>
            <div class="grid-row grid-gap-2  padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Book Shipment Id:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <b>{{ bookShipmentInfo.bookShipmentId }}</b>
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Relocating Employee's Name:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{bookShipmentInfo.employeeFirstName}} {{ bookShipmentInfo.employeeLastName}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Pick-up / Move Date:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.moveDate | date:'MM/dd/yyyy'}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Pick-up / Move Time Range:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    From {{ shipmentInfo.moveTimeFrom }} To {{ shipmentInfo.moveTimeTo }}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Estimated Mileage:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.miles}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='HHG'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Vehicle Shipped:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.vehicleType}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='HHG'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    PBP&E:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.professionalBooksEquipments === 1 ? 'Yes' : 'No'}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='HHG'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Pre-Move Survey Required:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{bookShipmentInfo.preMoveSurveyReqd}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='HHG'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Pre-Move Survey to be performed:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{bookShipmentInfo.preMoveSurveyType}}
                </div>
            </div>

            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='FRT'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Total Shipment Cube(Cubic Feet):
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.shipmentCubicFeet}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Bill of Lading Number:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{bolNumber}}
                </div>
            </div>
            
            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Confirmation Date & Time:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{bookShipmentInfo.confirmationDate | date:'MM/dd/yyyy, h:mm:ss a'}}
                </div>
            </div>

            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Response from TSP required within Days or Hours:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf=bookShipmentInfo.tspResponseInDays>
                    {{bookShipmentInfo.tspResponseInDays}} Days
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf=bookShipmentInfo.tspResponseInHours>
                    {{bookShipmentInfo.tspResponseInHours}} Hours
                </div>
            </div>

            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Required Delivery Date:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.requiredDeliveryDate | date:'MM/dd/yyyy'}}
                </div>
            </div>

            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Delivery Time Range:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    From {{ shipmentInfo.deliveryTimeFrom }} To {{ shipmentInfo.deliveryTimeTo }}
                </div>
            </div>

            <div class="grid-row grid-gap-2 padding-y-05">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Estimated Weight:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.weight}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='FRT'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Delivery Code Exception:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{this.delivertExceptionCode}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="shipmentType==='HHG'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Unaccompanied Air Baggage:
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    {{shipmentInfo.uabWeight}}
                </div>
            </div>
            <div class="grid-row grid-gap-2 padding-y-05" *ngIf="hasCarrierTrackingUrl()">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    Tracking Number:
                    (The TSP must provide a tracking URL to the Freight Management Program Office to enable tracking for this Shipment)
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <div class="display-flex flex-align-center" style="gap:0.75rem">
                        <input type="text" class="usa-input margin-top-0 flex-fill" style="max-width:200px" [(ngModel)]="trackingNumber" maxlength="50" autocomplete="off" aria-label="Tracking Number" [readonly]="!canEditTrackingNumber()">
                        <button type="button" class="usa-button margin-top-0 flex-auto" *ngIf="canEditTrackingNumber()" (click)="saveTrackingNumber()" [disabled]="!canEditTrackingNumber() || !trackingNumber || !trackingNumber.trim()">Save</button>
                    </div>
                    <small class="display-block margin-top-05 text-base-dark" *ngIf="carrier?.shipmentTrackingUrl">
                        <span>{{carrier?.shipmentTrackingUrl}}</span>
                    </small>
                </div>
                <div class="grid-col-12" *ngIf="!trackingNumber || !trackingNumber.trim()">
                    <div class="usa-alert usa-alert--warning usa-alert--slim margin-top-1">
                        <div class="usa-alert__body">
                            <p class="usa-alert__text">Tracking number is not available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="grid-row grid-gap-2 padding-bottom-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">STATUS: </legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="bookShipmentInfo.bookingStatus !== 'Accepted' && bookShipmentInfo.bookingStatus !== 'Accepted with Qualification'">
            {{bookShipmentInfo.bookingStatus}}
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="bookShipmentInfo.bookingStatus === 'Accepted' || bookShipmentInfo.bookingStatus === 'Accepted with Qualification'">
            <p> {{bookShipmentInfo.bookingStatus}} by {{shipmentConfirmedUserInfo.firstName}} {{shipmentConfirmedUserInfo.lastName}} on {{bookShipmentInfo.confirmationDate | date:'MM/dd/yyyy, h:mm:ss a'}}
                <p>
        </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="bookShipmentInfo.bookingStatus === 'Cancelled' && shipmentConfirmedUserInfo.firstName !== undefined">
        <p> BY {{shipmentConfirmedUserInfo.firstName}} {{shipmentConfirmedUserInfo.lastName}} ON {{bookShipmentInfo.updateDate | date:'MM/dd/yyyy, h:mm:ss a'}}
        <p>
      </div>
    </div>
    <div class="grid-row grid-gap-2" *ngIf="!isCarrierView && (bookShipmentInfo.bookingStatus === 'Cancelled') && shipmentType !== 'HHG'">
        <button type="button" class="usa-button define-margin-right" (click)="reactivateShipmentFropmCancelToBooked()">Reactivate Shipment</button>
    </div>
    <div class="grid-row grid-gap-2" [hidden]="bookShipmentInfo.bookingStatus === 'Cancelled'">
        <ul class="usa-button-group">
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="!bolNumber">
                <button type="button" class="usa-button define-margin-right" *ngIf="!isCarrierView" (click)="backToOnlineBooking()">Book Shipments</button>
                <button type="button" class="usa-button define-margin-right" *ngIf="isCarrierView && bookShipmentInfo.bookingStatus !== 'Expired'" (click)="backToOnlineBooking()">Review Shipments</button>
                <button type="button" class="usa-button define-margin-right" *ngIf="!isCarrierView && shipmentType ==='FRT' &&
                        (bookShipmentInfo.bookingStatus !== 'Refused' && bookShipmentInfo.bookingStatus !== 'Expired') &&
                        (bookShipmentInfo.oneTimeOnly === null)" (click)="DuplicateShipment()">Duplicate Shipments</button>
            </li>
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="bolNumber">
                <button type="button" class="usa-button define-margin-right" *ngIf="!isCarrierView" (click)="backToOnlineBooking()">Modify Bill Of Lading</button>
                <button type="button" class="usa-button define-margin-right" *ngIf="isCarrierView" (click)="backToOnlineBooking()">Review Shipments</button>
                <button type="button" class="usa-button define-margin-right" (click)="printBillOfLading()">Print Bill Of Lading</button>
                <button type="button" class="usa-button define-margin-right" *ngIf="(!isCarrierView && shipmentType ==='FRT') &&
                           (bookShipmentInfo.bookingStatus !== 'Refused' && bookShipmentInfo.bookingStatus !== 'Expired') &&
                           (bookShipmentInfo.oneTimeOnly === null)" (click)="DuplicateShipment()">Duplicate Shipments</button>
            </li>
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="!isCarrierView && (bookShipmentInfo.bookingStatus === 'Expired' || bookShipmentInfo.bookingStatus === 'Refused') && shipmentType !== 'HHG'">
                <button type="button" class="usa-button define-margin-right" (click)="requeryShipment()">ReQuery</button>
            </li>
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="!isCarrierView && (bookShipmentInfo.bookingStatus === 'Expired' || bookShipmentInfo.bookingStatus === 'Cancelled') && shipmentType !== 'HHG'">
                <button type="button" class="usa-button define-margin-right" (click)="reactivateShipment()">Reactivate Shipment</button>
            </li>
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="showDeliveryReportButton ">
                <button type="button " class="usa-button define-margin-right" (click)="navigateToShipmentDeliveryReport()">Update Delivery Info</button>
            </li>
            <li class="usa-button-group__item margin-0 padding-0" *ngIf="isSystemAdminView && bookShipmentInfo.bookingStatus === 'Complete' && isSyncadaPayment">
                <button type="button " class="usa-button define-margin-right" (click)="retransmitBolToSyncada()">Retransmit BOL to Syncada</button>
            </li>

            <li class="usa-button-group__item margin-0 padding-0" *ngIf="hasCarrierTrackingUrl()">
                <button type="button" class="usa-button define-margin-right" (click)="openTrackingWindow()" [disabled]="!bookShipmentInfo?.trackingNumber || !bookShipmentInfo?.trackingNumber?.trim()" aria-label="Track Shipment (opens in a new window)">Track Shipment
                    <span>
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#launch"></use>
                        </svg>
                    </span>
                </button>
            </li>


            <li class="usa-button-group__item margin-0 padding-0" *ngIf="!isCarrierView">
                <button type="button" class="usa-button usa-button--outline" (click)="cancelShipment() ">Cancel Shipment</button>
            </li>
        </ul>
    </div>
</div>
